import * as yup from "yup";
import { getValidationSchema } from "../../../../../../shared/validations/schema";
export const customizeValidationSchema = () => {

  let defaultSchema: any = getValidationSchema([    
  ]);
  
  let customSchema = yup.object().shape({
    secretKey: yup.string().required("Secret Pin is a required field")
    .min(6, "Secret Pin must be 6 characters")
    .max(6, "Secret Pin must be 6 characters"),
    
  });

  return defaultSchema.concat(customSchema);
};

export const customizeOtpValidationSchema = () => {

  let defaultSchema: any = getValidationSchema([    
  ]);
  
  let customSchema = yup.object().shape({
    otp: yup.string()
    .required('OTP is a required field')
    .matches(/^\d{4}$/, 'OTP must be a 4-digit number.'),
  });

  return defaultSchema.concat(customSchema);
};
